import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StorageUtilsService } from '../../services/storage-utils.service';

@Component({
    selector: 'rename-file-modal',
    templateUrl: './rename-file-modal.component.html',
    styleUrls: ['./rename-file-modal.component.scss'],
    standalone: false
})
export class RenameFileModalComponent implements OnInit {

  selectedFile!: any;
  renameObject!: any;

  isFolder: boolean;
  renameName: string = '';
  parentPath: string = '';
  extension: string = '';
  isProcessing: boolean = false;
  errorMessage: string = '';

  get validDestination() {
    return this.renameName && this.renameName.indexOf('/') === -1;
  }

  constructor (
    public dialogRef: MatDialogRef<RenameFileModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { selectedFile: any, renameObject: any },
    private storageUtilsService: StorageUtilsService,
    private ngZone: NgZone
  ) {
    this.selectedFile = data.selectedFile;
    this.renameObject = data.renameObject;
  }

  ngOnInit(): void {
    this.isFolder = this.storageUtilsService.fileName(this.selectedFile).endsWith('/');
    this.renameName = this.storageUtilsService.fileName(this.selectedFile).replace('/', '');
    this.parentPath = this.storageUtilsService.fileParent(this.selectedFile);
    if (!this.isFolder) {
      const extensionIndex = this.renameName.lastIndexOf('.');
      if (extensionIndex >= 0) {
        this.extension = this.renameName.substring(extensionIndex);
        this.renameName = this.renameName.substring(0, extensionIndex);
      }
    }
  }

  update () {
    this.ngZone.run(() => {});
  }

  ok () {
    this.errorMessage = '';
    this.isProcessing = true;

    let renameTo = this.renameName;
    if (this.extension) {
      renameTo += this.extension;
    }

    return this.renameObject(this.selectedFile, this.parentPath + renameTo)
      .then((resp) => {
        console.debug('Storage rename processed succesfully');

        this.dialogRef.close(resp);
      }, (e) => {
        if (e == 'cancel') {
          this.dialogRef.close(false);
        } else {
          console.error('Error renaming \'' + this.selectedFile.name + '\' to \'' +
            renameTo + '\'', e);

          this.errorMessage = StorageUtilsService.STORAGE_CLIENT_ERROR.rename[
            (e && e.result && e.result.error && e.result.error.message) || 'unknown'
          ];
        }
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  cancel () {
    this.dialogRef.close(false);
  }
}
